import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { CustomMessageModel, NewJoineeActivityModel } from 'src/app/models/api.model'
import { CommonService } from 'src/app/services/common/common.service'
import { CustomMessageService } from 'src/app/services/common/custom-message.service'
import { DynamicComponentLoaderService } from 'src/app/services/component-loader/dynamic-component-loader.service'
import { AppState } from 'src/app/store/state/app.state'

@Component({
  selector: 'app-new-joinee-workflow-notification-popup',
  templateUrl: './new-joinee-workflow-notification-popup.component.html',
  styleUrls: ['./new-joinee-workflow-notification-popup.component.scss']
})
export class NewJoineeWorkflowNotificationPopupComponent implements OnInit, OnDestroy {
  @ViewChild('selectpg-popup', { static: true }) selectPgPopup: ElementRef
  selectpgPopup: any

  private subscription: Subscription
  customMessage: CustomMessageModel
  newJoineeActivityDetails: NewJoineeActivityModel

  constructor(
    private customMessageService: CustomMessageService,
    private dynamicComponentLoaderService: DynamicComponentLoaderService,
    private elementRef: ElementRef,
    private cs: CommonService,
    private appState: Store<AppState>
  ) {}

  ngOnInit() {
    this.appState.select('initialize').subscribe(({ newJoineeActivityDetails }) => {
      this.newJoineeActivityDetails = newJoineeActivityDetails
    })
    this.checkCustomMessageAndShow()
  }

  checkCustomMessageAndShow() {
    this.subscription = this.customMessageService
      .getCustomMessage('NEW_JOINEE_ACTIVITY_AFTER_LOGIN_POPUP')
      .subscribe((customMessage) => {
        if (customMessage) {
          this.customMessage = customMessage
          this.selectpgPopup = this.elementRef.nativeElement.querySelector('#selectpg-popup')
          this.selectpgPopup.style.display = 'block'
        }
      })
  }

  closeModal() {
    this.dynamicComponentLoaderService.closeComponent(
      GlobalConstants.DYNAMIC_MODEL.NEW_JOINEE_WORKFLOW_NOTIFICATION_POPUP.key
    )
    this.selectpgPopup.style.display = 'none'
  }

  goToNewJoineeActivity() {
    this.closeModal()
    this.dynamicComponentLoaderService.closeComponent(
      GlobalConstants.DYNAMIC_MODEL.PENDING_FROM_EMPLOYEE_NOTIFICATION_POPUP.key
    )
    const url = `/${GlobalConstants.ROUTING.ACTIVITY}/${this.newJoineeActivityDetails.id}/${GlobalConstants.ROUTING.DETAILS}`
    this.cs.routeTo(url)
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }
}
